import { Routes, Route } from 'react-router-dom';
import paths from './paths';

const Router = () => {
  const notFoundPath = paths.find((path) => path.key === 'notFound');

  return (
    <Routes>
      {paths.map(({ component: Component, key, path }) => (
        <Route key={key} path={path} element={<Component />} />
      ))}
      {notFoundPath && (
        <Route path="*" element={<notFoundPath.component />} />
      )}
    </Routes>
  );
};

export default Router;
